import { completeTypes, createTypes, withPostSuccess } from 'redux-recompose';

import * as AdelphiFeintsService from '#services/AdelphiFeintsService';
import ModalActions from '#redux/Modal/actions';
import { MODALS } from '#redux/Modal/constants';

import { ADELPHI_FEINTS_TARGETS } from './constants';

export const actions = createTypes(
  completeTypes({
    primaryActions: [
      'CREATE_ADELPHI_FEINT',
      'DELETE_ADELPHI_FEINT',
      'GET_ALL_ADELPHI_FEINTS',
      'UPDATE_ADELPHI_FEINT_BY_ID',
      'GET_ADELPHI_FEINT_BY_ID'
    ],
    ignoredActions: ['SET_CURRENT_ADELPHI_FEINT']
  }),
  '@@ADELPHI_FEINTS'
);

export const actionCreators = {
  setCurrentFeint: payload => ({
    type: actions.SET_CURRENT_ADELPHI_FEINT,
    target: ADELPHI_FEINTS_TARGETS.CURRENT_ADELPHI_FEINT,
    payload
  }),
  createFeint: values => ({
    type: actions.CREATE_ADELPHI_FEINT,
    target: ADELPHI_FEINTS_TARGETS.CREATE_ADELPHI_FEINT,
    payload: values,
    service: AdelphiFeintsService.createAdelphiFeint,
    injections: [
      withPostSuccess(dispatch => {
        dispatch(actionCreators.getAllFeintsAndCloseModal(MODALS.ADELPHI_FEINT));
      })
    ]
  }),
  getAllFeints: () => ({
    type: actions.GET_ALL_ADELPHI_FEINTS,
    target: ADELPHI_FEINTS_TARGETS.ADELPHI_FEINTS,
    service: AdelphiFeintsService.getAllAdelphiFeints
  }),
  getFeintById: id => ({
    type: actions.GET_ADELPHI_FEINT_BY_ID,
    payload: id,
    target: ADELPHI_FEINTS_TARGETS.ADELPHI_FEINT_BY_ID,
    service: AdelphiFeintsService.getAdelphiFeintById,
    successSelector: response => response.data.feint
  }),
  updateFeintById: ({ id, values }) => ({
    type: actions.UPDATE_ADELPHI_FEINT_BY_ID,
    target: ADELPHI_FEINTS_TARGETS.UPDATE_ADELPHI_FEINT_BY_ID,
    payload: { id, values },
    service: AdelphiFeintsService.updateAdelphiFeintById,
    injections: [
      withPostSuccess(dispatch => {
        dispatch(actionCreators.getAllFeintsAndCloseModal(MODALS.ADELPHI_FEINT));
      })
    ]
  }),
  getAllFeintsAndCloseModal: modal => dispatch => {
    dispatch(actionCreators.getAllFeints());
    dispatch(actionCreators.setCurrentFeint(null));
    dispatch(ModalActions.closeModal(modal));
  },
  deleteFeint: ({ id }) => ({
    type: actions.DELETE_ADELPHI_FEINT,
    target: ADELPHI_FEINTS_TARGETS.DELETE_ADELPHI_FEINT,
    service: AdelphiFeintsService.deleteAdelphiFeintById,
    payload: { id },
    injections: [
      withPostSuccess(dispatch => {
        dispatch(actionCreators.getAllFeintsAndCloseModal(MODALS.DELETE_RECORD));
      })
    ]
  })
};

export default actionCreators;
